var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import Stack from '@mui/material/Stack';
import { colorPalette } from '../../../../colorPalette';
export const Section = (_a) => {
    var { children, sx, padding } = _a, rest = __rest(_a, ["children", "sx", "padding"]);
    return (React.createElement(Stack, Object.assign({ padding: padding || '16px', sx: Object.assign({ border: `1px solid ${colorPalette.gray200}`, borderRadius: '8px' }, sx) }, rest), children));
};
